import { Component } from '@angular/core';
import { MainLayout } from '../../../layouts/main-layout';
import { ContactFormComponent } from '../../../components/contacto/contact-form/contact-form';
import { Router } from '@angular/router';
import { ContactHeaderComponent } from '../../../components/shared/contact-header/contact-header';
import { AllasContactFooterComponent } from '../../../components/shared/ui/allas-contact-footer/allas-contact-footer';
import { basicFormFields } from '../../../types/Contact.types';
import { MarginWrapper } from '../../../layouts/margin-wrapper';

@Component({
  selector: 'allas-experiencia-tienda',
  imports: [
    MainLayout,
    ContactFormComponent,
    ContactHeaderComponent,
    AllasContactFooterComponent,
    MarginWrapper,
  ],
  template: `
    <allas-main-layout [showPopularSections]="true" [showNewsletter]="true">
      <allas-margin-wrapper styleClass="py-8">
        <!-- Botón Volver - Completamente a la izquierda -->
        <div class="px-6 py-1 sm:px-8">
          <button
            (click)="goBack()"
            class="flex items-center text-gray-600 hover:text-allasRed transition-colors mb-6"
          >
            <svg
              class="w-5 h-5 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M15 19l-7-7 7-7"
              ></path>
            </svg>
            VOLVER
          </button>
        </div>

        <section class="mx-auto mb-12 max-w-[80rem] px-6 sm:px-8">
          <allas-contact-header
            title="EXPERIENCIA EN TIENDA"
            subtitle="¿Tienes comentarios sobre una visita reciente a nuestra tienda? Podemos ayudarte con eso. Completa el formulario a continuación para que podamos contactarte. Por favor, ten cuidado de no incluir detalles de información personal."
          ></allas-contact-header>

          <!-- Contact Form -->
          <div class="rounded-lg p-2">
            <allas-contact-form
              category="repuestos-productos"
              [form]="form"
              (formSubmit)="onFormSubmit($event)"
              (formCancel)="goBack()"
            ></allas-contact-form>
          </div>

          <!-- Contact Footer -->
          <allas-contact-footer></allas-contact-footer>
        </section>
      </allas-margin-wrapper>
    </allas-main-layout>
  `,
})
export class ExperienciaTienda {
  form = basicFormFields;
  constructor(private router: Router) {
    this.form = {
      ...this.form,
      localidadDeLaTienda: {
        id: 'localidadDeLaTienda',
        label: 'Localidad de la Tienda',
        placeholder: 'Localidad de la Tienda',
        value: '',
        dirty: false,
      },
      departamento: {
        id: 'departamento',
        label: 'Departamento',
        placeholder: 'Departamento',
        value: '',
        dirty: false,
      },
      comentarios: {
        id: 'comentarios',
        label: 'Comentarios',
        placeholder: 'Describe tu consulta o comentario aquí...',
        value: '',
        dirty: false,
        type: 'textarea',
        fullWidth: true,
      },
    };
  }

  goBack() {
    this.router.navigate(['/contactanos']);
  }

  onFormSubmit(formData: any) {
    // Aquí se enviaría la información al backend
    alert('¡Gracias por tu mensaje! Te contactaremos pronto.');
    this.goBack();
  }
}
